import axiosInstance from '../config/axiosInstance';

export interface ExerciseCategory {
    id: string;
    key: string;
    label: string;
    emoji: string | null;
    isSeeded: boolean;
}

const categoryService = {
    async list(): Promise<ExerciseCategory[]> {
        const res = await axiosInstance.get('/exercise-categories');
        return res.data;
    },

    async create(label: string, emoji?: string): Promise<ExerciseCategory> {
        const res = await axiosInstance.post('/exercise-categories', { label, emoji });
        return res.data;
    },

    async remove(id: string): Promise<void> {
        await axiosInstance.delete(`/exercise-categories/${id}`);
    },
};

export default categoryService;
